<template>
  <div id="body">
    <b-row class="content-wrapper">
      <b-col sm="12">
        <div class='img-div' />
        <div class="content">
          <h1><span class='bi'>pricewagon</span></h1>
          <p><span class='bi'>pricewagon</span>은 각종 영양제들의 가성비를 수치화하여 제공합니다.</p>
          <p>영양제의 종류가 갈수록 많아지고 다양해지는 만큼, 어떤 영양제가 실제로 나에게 필요하며 경제적인지 알기가 점점 힘들어지고 있습니다.</p>
          <p>일부 영양제들은 부실한 영양성분과 과대 광고로 소비자들의 시야를 흐리게 합니다.</p>
          <p><span class='bi'>pricewagon</span>에서는 영양제에 들어있는 <b>핵심성분</b>만 조사하여 단위가격당 실제로 핵심성분이 얼마나 함유되어있는가를 계산해드립니다.</p>
          <p>영양성분의 함량이 영양제를 선택하는 유일한 기준은 아니겠지만 하나의 중요한 지표가 될 수는 있습니다.</p>
          <p>어떤 영양제가 가성비 좋은 영양제인지, <span class='bi'>pricewagon</span>이 알려 드리겠습니다.</p>
        </div>
        <div class="content">
          <h2><b-icon-check />100원당 함유량?</h2>
          <p>돈을 지불할 때는 내가 실제로 무엇을 얼마나 구입하는지를 정확히 알아야 합니다.</p>
          <p>내가 구입한 영양제에 핵심성분이 실제로 얼마나 들어있는지를 알기 위해 <b>100원당 핵심성분 함유량</b>이라는 새로운 지표를 제공합니다.</p>
          <p>100원을 냈을 때 실제로 핵심성분이 얼만큼 제공되느냐를 계산한 지표입니다.</p>
          <p>한알에 1g의 비타민C를 제공하는 영양제가 100알이 들어있는 통에 대해 5000원에 판매하는 경우, 100원당 비타민C 함유량은</p>
          <p>( 1g x 100 )/ 5000원 x 100원 = 2g 이 되겠죠.</p>
          <p>이 영양제는 100원을 냈을 때 비타민C 2g를 주는 셈입니다.</p>
          <p>이 수치가 높을 수록 <b>가성비가 좋은 영양제</b>라는 것을 알 수 있습니다.</p>
          <p>모든 영양소에 대해 <b>100원당 핵심성분 함유량</b>을 계산해서 가성비 좋은 영양제를 선택하세요.</p>
        </div>
        <div class="content">
          <h2><b-icon-check />About Us</h2>
          <p>데이터 분석을 좋아하며 취미로 개발을 하는 사람들이 모여서 만든 웹사이트입니다.</p>
          <p>영양제를 구입할 때마다 영양성분과 가성비를 계산하다가 다른 필요한 분들도 같이 공유하면 좋을 것 같아서 웹사이트로 만들었습니다.</p>
          <p>사이트나 제품에 관한 피드백은 언제나 환영입니다.</p>
          <p>실제 구매는 전적으로 쇼핑몰 홈페이지에서 이루어지므로 저희와는 무관합니다.</p>
          <p>각종 문의 사항은 <a href="mailto:agile.data.service@gmail.com">agile.data.service@gmail.com</a>로 주세요 :)</p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
  BIconCheck
} from 'bootstrap-vue'

export default {
  name: 'AboutComponent',
  components: {
    BRow, BCol,
    BIconCheck
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bi {
  color: #1E3E72;
  font-weight: 500;
}
.content-wrapper {
  position: relative;
  padding: 30px;
}
.img-div {    
  position: absolute;
  top: 0;
  background-size:100%;
  background: url("~/static/vitamin.png");
  background-position: right center;
  background-size: 300px 300px;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  opacity: 0.1;
}
.content {
  margin: 20px 0 80px;
}
.content > h1, h2 {
  margin-bottom: 50px;
}
.content > p {
  font-size: 1.1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/About.vue